module.exports = __webpack_public_path__ + "static/media/mp3-player.35e0fff1.svg";